<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="mx-1 mt-1 mb-0" v-if="detailData">
            <div class="row">
                <div class="col-lg-8">
                    <b-tabs content-class="mt-2" fill>
                        <b-tab title="Tedarikçi & Sipariş" active>
                            <b-card no-body class="border">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Tedarikçi Firma"><b-form-input :value="detailData.SupplierName" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Firma Sipariş No"><b-form-input :value="detailData.FuelOrderNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-12">
                                            <b-form-group label="Sipariş Edilen Ürün"><b-form-input :value="detailData.FuelTypeName" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Tedarikçi Belge No"><b-form-input :value="detailData.SupplierOrderNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Belge Türü"><b-form-input :value="detailData.SupplierDocumentType" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Fiyat Listesi"><b-form-input :value="detailData.SupplierPriceList" disabled /></b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>

                        <b-tab title="Nakliye & İrsaliye">
                            <b-card no-body class="border">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Çekici Plaka">
                                                <b-form-input :value="displayVehiclePlate" disabled />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Treyler Plaka">
                                                <b-form-input :value="displayTrailerPlate" disabled />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Sürücü">
                                                <b-form-input :value="displayDriverName" disabled />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Teslimat Yeri (Şube)"><b-form-input :value="detailData.DriverDestinationLocation" disabled /></b-form-group>
                                        </div>
                                        <div class="col-12"><hr class="my-1" /></div>
                                        <div class="col-md-4">
                                            <b-form-group label="e-İrsaliye No"><b-form-input :value="detailData.EWaybillNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="İrsaliye Tarihi"><b-form-input :value="detailData.EWaybillDate | formatDate" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Fiili Sevk Zamanı"><b-form-input :value="detailData.DispatchTime | formatDateTime" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="İrsaliye Miktarı (Litre)"><b-form-input :value="detailData.TransportLtValue | formatNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="İrsaliye Miktarı (Kg)"><b-form-input :value="detailData.TransportKgValue | formatNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Mühür Numaraları"><b-form-input :value="detailData.SealNumbers" disabled /></b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>
                        <b-tab title="Kantar Bilgileri">
                            <b-card no-body class="border">
                                <div class="card-body">
                                    <div class="p-1 border rounded">
                                        <h5 class="font-weight-bolder text-primary">Tartım #1</h5>
                                        <hr class="my-50" />
                                        <div class="row">
                                            <div class="col-12">
                                                <b-form-group label="Tartım Yapan Firma"><b-form-input :value="detailData.WeighingFirm1Name" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Fiş No"><b-form-input :value="detailData.WeighingFirm1DocumentNumber" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Giriş Zamanı"><b-form-input :value="detailData.WeighingFirm1StartDate | formatDateTime" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Çıkış Zamanı"><b-form-input :value="detailData.WeighingFirm1EndDate | formatDateTime" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group label="Dolu Ağırlık (kg)"><b-form-input :value="detailData.WeighingFirm1WeightValue1 | formatNumber" disabled class="text-danger font-weight-bold" /></b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group label="Boş Ağırlık (kg)"><b-form-input :value="detailData.WeighingFirm1WeightValue2 | formatNumber" disabled class="text-success font-weight-bold" /></b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="detailData.WeighingFirm2Id" class="p-1 border rounded mt-2">
                                        <h5 class="font-weight-bolder text-primary">Tartım #2</h5>
                                        <hr class="my-50" />
                                        <div class="row">
                                            <div class="col-12">
                                                <b-form-group label="Tartım Yapan Firma"><b-form-input :value="detailData.WeighingFirm2Name" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Fiş No"><b-form-input :value="detailData.WeighingFirm2DocumentNumber" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Giriş Zamanı"><b-form-input :value="detailData.WeighingFirm2StartDate | formatDateTime" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group label="Çıkış Zamanı"><b-form-input :value="detailData.WeighingFirm2EndDate | formatDateTime" disabled /></b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group label="Dolu Ağırlık (kg)"><b-form-input :value="detailData.WeighingFirm2WeightValue1 | formatNumber" disabled class="text-danger font-weight-bold" /></b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group label="Boş Ağırlık (kg)"><b-form-input :value="detailData.WeighingFirm2WeightValue2 | formatNumber" disabled class="text-success font-weight-bold" /></b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>
                        <b-tab title="Teslim Tesellüm Tutanağı">
                            <b-card no-body class="border">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <b-form-group label="Sipariş No"><b-form-input :value="detailData.FuelOrderNumber" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Teslimat Zamanı">
                                                <b-form-input :value="detailData.ReportDeliveryDate | formatDateTime" disabled />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-group label="Şube Adı"><b-form-input :value="detailData.DriverDestinationLocation" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Çekici Plaka"><b-form-input :value="displayVehiclePlate" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Treyler Plaka"><b-form-input :value="displayTrailerPlate" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Sürücü"><b-form-input :value="displayDriverName" disabled /></b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Şahit Numune Seri No"><b-form-input :value="detailData.WitnessSampleSerialNo" disabled /></b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-tab>
                        <b-tab title="Dosyalar">
                            <div class="row">
                                <div class="col-md-6 mb-1">
                                    <file-display-card label="e-İrsaliye Dosyası" :url="detailData.IrsaliyeFile" />
                                </div>
                                <div class="col-md-6 mb-1">
                                    <file-display-card label="Teslim Tesellüm Fişi" :url="detailData.TeslimatFile" />
                                </div>
                                <div class="col-md-6 mb-1">
                                    <file-display-card label="Kantar #1 Fişi" :url="detailData.Kantar1File" />
                                </div>
                                <div class="col-md-6 mb-1">
                                    <file-display-card label="Kantar #2 Fişi" :url="detailData.Kantar2File" />
                                </div>
                                <div class="col-md-6 mb-1">
                                    <file-display-card label="Analiz Raporu" :url="detailData.LabFile" />
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>

                <div class="col-lg-4">
                    <div class="sticky-wrapper mb-2">
                        <b-card title="İşlem Özeti" class="mb-2 border">
                            <b-form-group label="Durum">
                                <b-badge variant="light-success" class="p-50 w-100">Evraklar İşlenmiş</b-badge>
                            </b-form-group>
                            <b-button variant="warning" class="w-100" @click="goToUpdatePage">
                                <feather-icon icon="EditIcon" class="mr-50" />
                                Evrak Bilgilerini Güncelle
                            </b-button>
                        </b-card>
                        <b-card title="Laboratuvar Analiz Değerleri" class="mb-2 border">
                            <div class="row">
                                <div class="col-6">
                                    <b-form-group label="Sıcaklık (°C)"><b-form-input :value="detailData.TemperatureValue | formatNumber" disabled /></b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group label="Yoğunluk"><b-form-input :value="detailData.FuelDensityValue | formatNumber" disabled /></b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group label="Setan Sayısı"><b-form-input :value="detailData.SetanNumber | formatNumber" disabled /></b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group label="Kükürt"><b-form-input :value="detailData.SulfurValue | formatNumber" disabled /></b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group label="FAME"><b-form-input :value="detailData.FameValue | formatNumber" disabled /></b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group label="Parlama Nok."><b-form-input :value="detailData.FlashPointValue | formatNumber" disabled /></b-form-group>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!loading" class="text-center py-5">
            <h4>Bu siparişe ait işlenmiş evrak kaydı bulunamadı.</h4>
        </div>
    </b-overlay>
</template>

<script>
import { BCard, BOverlay, BFormGroup, BFormInput, BBadge, BButton, BTabs, BTab } from "bootstrap-vue";
import api from "@/api/fuel-storage";
import router from "@/router";
import FileDisplayCard from "../components/FileDisplayCard.vue";

export default {
    name: "FuelOrderDetailView",
    components: { BCard, BOverlay, BFormGroup, BFormInput, BBadge, BButton, BTabs, BTab, FileDisplayCard },
    props: {
        fuelOrderId: { type: String, required: true },
    },
    data() {
        return {
            loading: false,
            detailData: null,
        };
    },
    watch: {
        fuelOrderId: {
            immediate: true,
            handler(id) {
                if (id) this.loadDetails(id);
            },
        },
    },
    filters: {
        formatDate(value) {
            if (!value) return "";
            return new Date(value).toLocaleDateString("tr-TR");
        },
        formatDateTime(value) {
            if (!value) return "";
            return new Date(value).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
        },
        formatNumber(value) {
            if (value === null || value === undefined) return "0,00";
            return value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
    },
    computed: {
        isAdBlue() {
            return this.detailData?.FuelTypeName?.toLowerCase().includes("adblue") || false;
        },
        displayVehiclePlate() {
            if (!this.detailData) return "";
            return this.isAdBlue ? this.detailData.AdblueCarrierVehiclePlate : this.detailData.VehiclePlateValue;
        },
        displayTrailerPlate() {
            if (!this.detailData) return "";
            return this.isAdBlue ? this.detailData.AdblueCarrierVehicleTrailerPlate : this.detailData.TrailerPlateValue;
        },
        displayDriverName() {
            if (!this.detailData) return "";
            return this.isAdBlue ? this.detailData.AdblueCarrierFullName : this.detailData.DriverEmployeeName;
        },
    },
    methods: {
        loadDetails(orderId) {
            this.loading = true;
            this.detailData = null;
            api.FuelOrderDetail.GetByFuelOrderId(orderId)
                .then((res) => {
                    if (res.data.Success) {
                        this.detailData = res.data.Data;
                    }
                })
                .catch((err) => {
                    this.$result(null, "Detay verileri yüklenirken bir hata oluştu.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToUpdatePage() {
            router.push({ name: "fuel-order-document-form", params: { id: this.fuelOrderId } });
        },
    },
};
</script>

<style scoped>
.sticky-wrapper {
    position: -webkit-sticky;
    position: sticky;
    top: 15px;
}
</style>
